import { FC, useMemo } from 'react';

interface IImageThemeProps {
  lightImageName: string;
  darkImageName?: string;
  className?: string;
  applicationTheme: 'dark' | 'light';
}

export const ImageTheme: FC<IImageThemeProps> = (props) => {
  const { darkImageName, lightImageName, className } = props;

  const imageName = useMemo(() => {
    if (props.applicationTheme === 'light') {
      return lightImageName;
    }

    return darkImageName || lightImageName;
  }, [lightImageName, darkImageName]);

  if (!imageName) {
    return null;
  }

  return (
    <img
      src={imageName}
      className={className}
      alt={''}
    />
  );
};
